import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("tk_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Auto logout on auth failure (token missing/rejected, account deactivated mid-session, brand expired).
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail || "";
    const authFailed =
      status === 401 ||
      (status === 403 && /deactivat|brand deactivat|account deactivat/i.test(String(detail)));
    if (authFailed && localStorage.getItem("tk_token")) {
      localStorage.removeItem("tk_token");
      // Preserve the login route so the user can sign back in.
      const path = window.location.pathname;
      const dest =
        path.startsWith("/admin") ? "/admin-login" :
        path.startsWith("/superadmin") ? "/superadmin-login" :
        "/login";
      if (window.location.pathname !== dest) window.location.replace(dest);
    }
    return Promise.reject(err);
  },
);

export function formatError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(d);
}
